import * as React from "react";
import { MediaQuery } from "react-responsive";
import { Anchor } from "../../typography/anchor/anchor.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { List } from "../../list/list/list.mjs";
import { ListItem } from "../../list/list-item/list-item.mjs";
import { ScrollFade } from "../../scroll-fade/scroll-fade.mjs";
import { useTheme } from "../../helpers/theme-provider/use-theme.mjs";
const HeaderSegment = (props) => {
  const { media } = useTheme();
  const BEM = () => {
    const classArray = ["header__segment"];
    if (props.color) {
      classArray.push("header__segment--" + props.color);
    }
    return classArray.join(" ");
  };
  const segmentItemBEM = (item) => {
    const classArray = [];
    if (item.icon) {
      classArray.push("header__segment-item-with-icon");
    } else {
      classArray.push("header__segment-item");
    }
    if (item.current) {
      classArray.push("is-current");
    }
    if (item.employee) {
      classArray.push("is-employee");
    }
    return classArray.join(" ");
  };
  const getItems = () => {
    return props.items.map((item, index) => {
      const itemLabel = item.mobileLabel ? /* @__PURE__ */ React.createElement(MediaQuery, { minWidth: media.width.sm.min }, (matches) => /* @__PURE__ */ React.createElement("div", null, matches ? item.label : item.mobileLabel)) : item.label;
      return /* @__PURE__ */ React.createElement(ListItem, { className: segmentItemBEM(item), key: index }, /* @__PURE__ */ React.createElement(
        Anchor,
        {
          url: item.url,
          isUnderlined: false,
          onClick: item.onClick,
          className: "header__segment-link",
          attributes: {
            "aria-current": item.current ? "true" : void 0
          }
        },
        item.icon ? /* @__PURE__ */ React.createElement(Grid, { noWrap: true, align: ["middle-xs"], gutter: "none" }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React.createElement(Icon, { ...item.icon, className: "header__segment-icon" })), /* @__PURE__ */ React.createElement(GridColumn, { width: ["max"] }, itemLabel)) : itemLabel
      ));
    });
  };
  const list = /* @__PURE__ */ React.createElement(List, { type: "unstyled", direction: "inline", spacing: "none", fullWidth: true, className: "header__segment-list" }, getItems());
  return /* @__PURE__ */ React.createElement("div", { className: BEM() }, props.scrollable ? /* @__PURE__ */ React.createElement(ScrollFade, null, list) : list);
};
export {
  HeaderSegment
};
